import routes from '@/modules/company/company-routes';
import store from '@/modules/company/company-store';

export default {
  routes,
  store,
};
